import { DataLoadingWrapper } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { useAgentAnalyticsContext } from "@jugl-web/domain-resources/analytics";
import { AnalyticsPageHeader } from "../AnalyticsPageHeader";
import { ImpactDistributionWidget } from "../ImpactDistributionWidget";
import { ImpactOverviewWidget } from "../ImpactOverviewWidget";

export const BusinessImpactTabContent: FC = () => {
  const {
    impactDistributionData,
    impactDetailsById,
    impactOverviewWidgetData,
    isLoading,
    isError,
    refetch,
  } = useAgentAnalyticsContext();

  const { t } = useTranslations();

  return (
    <DataLoadingWrapper
      isLoading={isLoading}
      isError={isError}
      onRetry={() => refetch()}
    >
      <div className="mx-auto flex w-full flex-col gap-10 p-12">
        <AnalyticsPageHeader
          title={t({
            id: "cx-analytics.business-impact-tab-title",
            defaultMessage: "Business Impact",
          })}
          subtitle={t({
            id: "cx-analytics.business-impact-tab-subtitle",
            defaultMessage:
              "Turn conversation insights into measurable business impact across revenue and operations",
          })}
          hints={[
            t({
              id: "cx-analytics.business-impact-hint-1",
              defaultMessage:
                "See how conversations impact your business, including revenue opportunities and operational issues 🏹",
            }),
            t({
              id: "cx-analytics.business-impact-hint-2",
              defaultMessage:
                "Each session represents a single customer conversation within a short period of time across any channel 💬",
            }),
            t({
              id: "cx-analytics.business-impact-hint-3",
              defaultMessage:
                "Use this data to understand trends and improve performance 🚀",
            }),
          ]}
        />
        <div className="flex flex-col gap-14">
          <ImpactDistributionWidget data={impactDistributionData} />
          <ImpactOverviewWidget
            data={impactOverviewWidgetData}
            impactDistributionData={impactDistributionData}
            impactDetailsById={impactDetailsById}
          />
        </div>
      </div>
    </DataLoadingWrapper>
  );
};
